module.exports = "/assets/data/81ff897dcff163eddba3d5fdbca8ed56-GU7.data.json";